export const responseIsInvalidPromotion = (err) => {
  let errorMsg = "";
  if (!err || !err.response || !err.response.data) {
    return false;
  }
  if (err.response.data.error && err.response.data.error.detail) {
    errorMsg = err.response.data.error.detail;
  }
  if (err.response.data.message) {
    errorMsg = err.response.data.message;
  }
  if (errorMsg === "") {
    return false;
  }
  const regEx = /invalid\s*(concession|promotion)/i;
  if (regEx.test(errorMsg)) {
    return true;
  }
  return false;
};
